import React from 'react';

const Denied = () => (
    <div
        className='d-flex justify-content-center align-items-center'
        style={{
            height: '100vh'
        }}
    >
        <img
            src='https://media.tenor.com/images/d499709138e770810c00dbaa0aab80d9/tenor.gif'
            alt='Nope'
        />
    </div>
)

export default Denied;